<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JjXsRf/tc-custom/FC-9781528945035.jpg?1685327250453?1709061378335" alt="This image is the cover for the book Stained Glass Window"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stained Glass Window
      </h1>
      <p class="bookDescription body article font2">
        <p>Ever thought that being severely visually impaired means that you have no vision? Louise Jordan has always seen it like that, but during her week of work experience at Firtops, a Residential Care Home, she begins to realise that there could be some light at the end of her own particular tunnel, despite her disability.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Verity Landon
      </h2>
      
      <p class="authorDescription body article">Verity Landon was born in 1985 in Surrey, where she has lived ever since. Soon after her birth, it became obvious to her parents that she had problems with her vision, but despite being registered visually impaired, she went to mainstream primary and secondary schools, where her love of writing soon became apparent. While still at school, she won two county competitions for short stories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e9349bf